import { MAX_IMAGE_WIDTH, imageVariantUrl, isTransformable, withImageParams } from "~/lib/image-url";

const TYPES: Record<string, string> = { jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png", gif: "image/gif", webp: "image/webp" };

// CSS image-set() for background-image/mask-image usages of an `imageUrl()` URL — the CSS
// equivalent of components/ui/picture.tsx's <Picture>. On imgix it offers 1x and 2x widths (`width`
// is the CSS width the image is painted at; full-bleed backgrounds can keep the default); otherwise
// it lists the pre-generated .avif/.webp twins ahead of the original.
export function imageSet(url: string, { width = 1920 }: { width?: number } = {}) {
  if (isTransformable(url)) {
    const at = (w: number) => withImageParams(url, { w: Math.min(w, MAX_IMAGE_WIDTH), fit: "max" });
    return `image-set(url(${at(width)}) 1x, url(${at(width * 2)}) 2x)`;
  }
  const ext = url.match(/\.([^./]+)$/)?.[1] ?? "jpg";
  const candidates = [
    ...(["avif", "webp"] as const).flatMap((v) => {
      const u = imageVariantUrl(url, v);
      return u ? [`url(${u}) type("image/${v}")`] : [];
    }),
    `url(${url}) type("${TYPES[ext] ?? "image/jpeg"}")`,
  ];
  return `image-set(${candidates.join(", ")})`;
}
